module.exports = __webpack_public_path__ + "img/cmccLog.f3abf6bd.jpg";